var _rect, _path, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect3, _path9, _rect4, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlsxicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.44226,
    y: 1.07812,
    width: 13.5597,
    height: 15.6605,
    fill: "url(#pattern0_12376_143951)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5453 1.16406H5.79468C5.42112 1.16406 5.11829 1.46689 5.11829 1.84046V14.8352C5.11829 15.2087 5.42112 15.5115 5.79468 15.5115H16.5453C16.9189 15.5115 17.2217 15.2087 17.2217 14.8352V1.84046C17.2217 1.46689 16.9189 1.16406 16.5453 1.16406Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.12
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.75916,
    y: 1.01562,
    width: 12.7958,
    height: 14.8966,
    fill: "url(#pattern1_12376_143951)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5436 1.16797H5.79297C5.41941 1.16797 5.11658 1.4708 5.11658 1.84436V14.8391C5.11658 15.2126 5.41941 15.5154 5.79297 15.5154H16.5436C16.9172 15.5154 17.22 15.2126 17.22 14.8391V1.84436C17.22 1.4708 16.9172 1.16797 16.5436 1.16797Z",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3878 1.17192H5.81753C5.72946 1.17086 5.64206 1.18742 5.56048 1.22063C5.47889 1.25384 5.40478 1.30304 5.3425 1.36532C5.28021 1.42761 5.23102 1.50172 5.1978 1.5833C5.16459 1.66488 5.14803 1.75228 5.1491 1.84036V4.75283H11.4197L11.3878 1.17192Z",
    fill: "#21A366"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5442 1.17192H11.3877V4.75282H17.2206V1.8324C17.2195 1.74462 17.2012 1.6579 17.1667 1.5772C17.1321 1.4965 17.082 1.42339 17.0192 1.36206C16.9564 1.30073 16.8821 1.25237 16.8006 1.21975C16.7191 1.18712 16.632 1.17087 16.5442 1.17192Z",
    fill: "#33C481"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2126 8.33594H11.3877V11.9248H17.2126V8.33594Z",
    fill: "#107C41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3871 11.9248V8.33594H5.1165V14.8373C5.11544 14.9253 5.132 15.0127 5.16521 15.0943C5.19842 15.1759 5.24762 15.25 5.3099 15.3123C5.37219 15.3746 5.4463 15.4238 5.52788 15.457C5.60946 15.4902 5.69686 15.5068 5.78494 15.5057H16.5436C16.632 15.5068 16.7198 15.4902 16.8018 15.4571C16.8838 15.424 16.9585 15.3749 17.0214 15.3128C17.0843 15.2506 17.1342 15.1765 17.1683 15.0949C17.2024 15.0133 17.22 14.9257 17.22 14.8373V11.9248H11.3871Z",
    fill: "#185C37"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.395 4.74609H5.11646V8.33495H11.395V4.74609Z",
    fill: "#107C41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2126 4.74609H11.3877V8.33495H17.2126V4.74609Z",
    fill: "#21A366"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.48
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 3.32031,
    width: 11.2679,
    height: 11.2679,
    fill: "url(#pattern2_12376_143951)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.48
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9204 4.30078H2.20422C1.83066 4.30078 1.52783 4.60361 1.52783 4.97717V11.6934C1.52783 12.0669 1.83066 12.3697 2.20422 12.3697H8.9204C9.29397 12.3697 9.5968 12.0669 9.5968 11.6934V4.97717C9.5968 4.60361 9.29397 4.30078 8.9204 4.30078Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.24
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.3219,
    y: 4.07031,
    width: 8.59416,
    height: 8.59416,
    fill: "url(#pattern3_12376_143951)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.24
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92114 4.30078H2.20496C1.8314 4.30078 1.52856 4.60361 1.52856 4.97717V11.6934C1.52856 12.0669 1.8314 12.3697 2.20496 12.3697H8.92114C9.2947 12.3697 9.59753 12.0669 9.59753 11.6934V4.97717C9.59753 4.60361 9.2947 4.30078 8.92114 4.30078Z",
    fill: "white"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9204 4.30078H2.20422C1.83066 4.30078 1.52783 4.60361 1.52783 4.97717V11.6934C1.52783 12.0669 1.83066 12.3697 2.20422 12.3697H8.9204C9.29397 12.3697 9.5968 12.0669 9.5968 11.6934V4.97717C9.5968 4.60361 9.29397 4.30078 8.9204 4.30078Z",
    fill: "#107C41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61194 10.5212L5.02043 8.33286L3.7313 6.15249H4.77374L5.47401 7.5371C5.5273 7.63403 5.57254 7.73516 5.60929 7.83949C5.65329 7.73305 5.70378 7.62941 5.76048 7.52915L6.55624 6.14453H7.51114L6.1504 8.33286L7.51114 10.5371H6.49258L5.69682 9.0013C5.65445 8.93939 5.61971 8.87259 5.59337 8.80236C5.56692 8.87112 5.53498 8.93764 5.49788 9.0013L4.65438 10.5371L3.61194 10.5212Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5,
    d: "M8.92077 4.30078H2.20459C1.83103 4.30078 1.5282 4.60361 1.5282 4.97717V11.6934C1.5282 12.0669 1.83103 12.3697 2.20459 12.3697H8.92077C9.29433 12.3697 9.59716 12.0669 9.59716 11.6934V4.97717C9.59716 4.60361 9.29433 4.30078 8.92077 4.30078Z",
    fill: "url(#paint0_linear_12376_143951)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_12376_143951",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_12376_143951",
    transform: "scale(0.0138889 0.0120482)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_12376_143951",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_12376_143951",
    transform: "scale(0.0147059 0.0126582)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_12376_143951",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_12376_143951",
    transform: "scale(0.0166667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3_12376_143951",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_12376_143951",
    transform: "scale(0.0217391)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12376_143951",
    x1: 2.92873,
    y1: 3.77558,
    x2: 8.19663,
    y2: 12.8949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_12376_143951",
    width: 72,
    height: 83,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABTCAYAAAA8/EEfAAAACXBIWXMAAC4jAAAuIwF4pT92AAAB4ElEQVR4Xu3cwWrUUABG4XPbUMGNCnYhOM/hpjtfXRDtYziioFRcNqZeF/dmJh3aHnCZ/GeTdiab+5HJ8i+1VpaVUgobrJ5C9Mr8eYcZgAvgHNgKVAXugBGYTqFKrXXGeQZcAm+BF2wDacb5DeyBH8DtEmlYXC+Bd8AVsKM9SVtoBL4AH4BPwHfgz/zl0J+eC9qTcwW8B95wxFt7E/Ct//0VuCmlHH5qM8I57We1o+G8BM7YRn/7dcfx1XJoBlq+oAcaztrfP3Nn3D/7vXNv5Sn57wIkBUgKkBQgKUBSgKQASQGSAiQFSAqQFCApQFKApABJAZICJAVICpAUIClAUoCkAEkBkgIkBUgKkBQgKUBSgKQASQGSAiQFSAqQFCApQFKApABJAZICJAVICpAUIClAUoCkAEkBkgIkBUgKkBQgKUBSgKQASQGSAiQFSAqQFCApQFKApABJAZICJAVICpA0A1XaXN7Yrw/Odq60J88+r+At1yh/As9py5xrX8KrwC3tzHuawd3yhqHWWkspY7/hI/Cqf/ea9Y9NTjScz7Sz74HxoanSibZjet3//0Vb5lz7XOnywbimGUzLG07XgLc0eKtDt7AAgk1OJj85lQwnQIcPNza6/djYNjwClI79A/7Gf1JmIOGZAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_12376_143951",
    width: 68,
    height: 79,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABPCAYAAABS1GNxAAAACXBIWXMAAC4jAAAuIwF4pT92AAABY0lEQVR4Xu3cvW3bYAAG4aNggEuo8xLp0nmhdB7AnQdy5zITuIo6DSFWXwqK/jkkQWrxHoCFBEoAD59UvtMYg3y4+/ximqYZOALzn2+/SQtwHmMsANN2Qq4xvgGPrFH24gw8AT/HGAtjDK5R7oEX4AKMHV0X4BX4DsxbjBl4AH79xxfc4nVhPQz3B1ZH4Af7+ql89v7fefAbf/3IThzIFwWRgkhBpCBSECmIFEQKIgWRgkhBpCBSECmIFEQKIgWRgkhBpCBSECmIFEQKIgWRgkhBpCBSECmIFEQKIgWRgkhBpCBSECmIFEQKIgWRgkhBpCBSECmIFEQKIgWRgkhBpCBSECmIFEQKIgWRgkhBpCBSECmIFEQKIgWRgsgWZGHd81r+ce8t+3j+ZrsYrM/9AMx3AGOMZZqmE/DGai+LVdvJeANOY4zF039H1sW7vWyanYFn4MR1D/E9yGZnA5FfhiEBfgO20QT8sY3jjAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_12376_143951",
    width: 60,
    height: 60,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAAC4jAAAuIwF4pT92AAADoUlEQVRoQ+2b61LbMBBGj3IhoUAphbbT93+6Ti8DoZCEXNwfq43WshyHUizi+pvZ8SWO2ONd2WH82RVFwf+kUdMBKTnnXNMxr63iLyvl9n3PgFnA7LBGhV0echJqgT2sAwZ+add3hyW++tqykBpbu70PPAnsnBsgcANgGIU9AbmANTaJ2ALbOujKHDawI2AMnJgY+dBjoF1ohdgicGtgBTyZWAE455LQJWDfxgo7AabAO+AMOPX7TqhWui3ZFl4jgHPg0YTz+5PQO+Bozo4RwAvg0sd7BH7qPx/S3ny2SWt1Vwjsb2AG3CI56fE2dopbWqt7gsBdAp+AG+Cj3z6lXOU2pQBrYAk8AHfATwJLaT4755ytsgXWCg+R1j0DPiDAX4HPwBVwTpjPOVpa23kJ3AO/kHwx+5dIW6/jAVIVHiJAp0gbXwNfEOhrpM0nhJbOAbwBFkgrT/1nWvF7v9QO1FsWUAXWCo+Rgc4Q6CukrW/ID6wtvSBUdoG09jlSqNQ1BvDA5oKlFy2tsl6lz31c8DaAN0h+IJW9INxJdLol80v9lrbQ9l48iSI3MMg8nRJyGpOAtReuVEvr0oLbGJn1NmFVOh9tLiOzrj+KkrnVVTgVdiAbOVSXlwVN5nfofTT+Yi5QVV1RiNYragLODfbP1QR8bGosUNeAG9UDd109cNfVA3ddPXDX1QN3XT1w19UDd109cNfVA3ddPXDX1QMfuWrdO6om4MYBjk1NwKoYPPeJiD0c1stR8XVY1VkP4wHsvvgPtK04hy3hKb992p/MMQauGyxlAIP2nyBqXprD2ix13Z6AilIVtoOq8UvNX0vCk/ccz4dtbgsTamRZEcB3Fa64eIqiKLyPVKuqsEs/4IMPNZA8kRdYPR4zH2pkmRPcOyVola2wbeMVAvvoB7tF/BMgf0h9WjmAYxfPD8S6dIeY1OZI/gpcUmoOq8tNYa0Pao6YR9QlA+1CK3Ds0/qGmNNmSN5PhPm8t8J69rS6d5TdMrcE66G1F7Ql29KxE+87kp8FPqjCatp8RAbAb88QC9OE4KhVvTa4TXyf1zKucMU7vQP2F664pUFOgFZbYXNYlqB8nalz0y6Q/JO3ppJB3BjU1I1nPVq6bWFzAEOzX3pDjUm84oiPbMSxL2tAmLttw6oKE6kfRHsd8XWvAMR2oEG0jVm2rcIsbYvvtp/9zsPuw+pbLbkg62ThX/ZWS53ewjtLcBhcSs8GPnYd+v9wZ/QHTbqvfA0XAmsAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3_12376_143951",
    width: 46,
    height: 46,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAwUlEQVRoQ+3ZsQkCMRyF8S8iZAm765zAzr0cwJ3sLG8BN8gQSfW3CIdeZ/VM4P0gTSDwcXDVSxFBSikDJyAzpgaUiGjbRaLHXoAbPX5EBbgD63f8AjyACsSgpwJP4ArkiADgDLx+ePzvU+kfeIkIDsxj9x/OFL7jcDWHqzlczeFqDldzuJrD1Ryu5nA1h6s5XM3hag5Xc7iaw9UcruZwNYcLNPre2aCH7y4G1YCVPtIWgCOf1RYmWpbTtFv+Ni/P5g1xTodLg4W2uAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsxicon);
export default __webpack_public_path__ + "static/media/xlsxicon.1088eae068482003d9f4c8af6e5f0891.svg";
export { ForwardRef as ReactComponent };